export enum ExtraInformationType {
    INFO,
    TIP
}
